module.exports = __webpack_public_path__ + "media/images/browsers/chrome-888d0c163d8c67fa4f9b5ed009259258.svg";